import React, { useContext } from "react";
import { EventGalleryContext } from "./index";
import { Event, Photo } from "./types";
import _ from "lodash";

interface PhotoPricingProps {
  event: Event;
  photo: Photo;
  freeEvent: boolean;
}

const PhotoPricing: React.FC<PhotoPricingProps> = ({
  event,
  photo,
  freeEvent
}) => {
  const {
    cart,
    arePrepaidPhotosAvailable,
    event: contextEvent
  } = useContext(EventGalleryContext);

  const isPrepaid =
    cart &&
    (arePrepaidPhotosAvailable || _.includes(cart.prepaidPhotos, photo.id));

  return (
    <div className="geo-img-leftcont">
      {freeEvent ? (
        <div className="prepaid">
          <span className="free"> Free </span>
          <p>*for High quality digital download</p>
        </div>
      ) : isPrepaid ? (
        <div className="prepaid">
          <span className="prepaid-strike">{contextEvent.displayPrice} </span>
          <span className="currency">{contextEvent.currency}</span>
          <span className="free"> Free </span>
          <p>*for High quality digital download</p>
        </div>
      ) : (
        <>
          <h3>
            <strong>{event.displayPrice}</strong> <span>{event.currency}</span>
          </h3>
          <p>*for High quality digital download</p>
        </>
      )}
    </div>
  );
};

export default PhotoPricing;
